/** BLU-835 shared contracts for manual Portless parcel-label imports. */
export const MANUAL_LABEL_LIMITS = {
    maxFiles: 100,
    maxBatchBytes: 250 * 1024 * 1024,
    maxFileBytes: 20 * 1024 * 1024,
    // Portless sends combined label runs rather than one file per order. Real
    // production files already exceed the original 50-page assumption, so one
    // document must be able to carry a full 200+ order run with headroom.
    maxPagesPerFile: 500,
    maxPagesPerBatch: 1_000,
    signedTargetsPerRequest: 20,
    browserUploadConcurrency: 4,
    parserConcurrencyPerProcess: 2,
};
